import _extends from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React from 'react';
var SvgIdSuccessIcon = function SvgIdSuccessIcon(props) {
  return __jsx("svg", _extends({
    height: "36",
    viewBox: "0 0 54 36",
    width: "54",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), __jsx("defs", null, __jsx("path", {
    id: "a",
    d: "m5 9.638 1.78-1.79 1.605 1.75 4.323-3.598 1.292 1.317-5.655 5.683z"
  }), __jsx("filter", {
    id: "b",
    height: "128.6%",
    width: "111.1%",
    x: "-5.6%",
    y: "-7.1%"
  }, __jsx("feOffset", {
    dy: "1",
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), __jsx("feColorMatrix", {
    "in": "shadowOffsetOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.111752717 0"
  }))), __jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, __jsx("g", {
    transform: "translate(0 4.4)"
  }, __jsx("rect", {
    height: "28",
    rx: "3.72",
    stroke: "#60a58a",
    strokeWidth: "3",
    width: "45",
    x: "1.5",
    y: "1.5"
  }), __jsx("path", {
    d: "m6.5 6.333h17.5v18.333h-17.5z",
    fill: "#d8ede2",
    fillRule: "nonzero"
  }), __jsx("path", {
    d: "m20.2 20.647c-2.317-.79-3.027-1.465-3.027-2.929 0-.857.703-.578 1.012-2.153.131-.651.772 0 .865-1.5 0-.594-.34-.733-.34-.733s.17-.879.24-1.56c.084-.798-.518-2.994-3.7-2.994s-3.784 2.196-3.7 3.024c.07.673.24 1.56.24 1.56s-.34.146-.34.732c.116 1.464.773.849.865 1.5.31 1.575 1.012 1.297 1.012 2.153 0 1.465-.734 2.102-3.027 2.93-2.294.827-3.8 1.573-3.8 2.13v1.86h17.5v-1.86c0-.557-1.499-1.362-3.8-2.16",
    fill: "#60a58a"
  }), __jsx("g", {
    fill: "#b2dbc5",
    fillRule: "nonzero"
  }, __jsx("rect", {
    height: "3.667",
    rx: "1.833",
    width: "13.75",
    x: "27.75",
    y: "7.556"
  }), __jsx("rect", {
    height: "3.667",
    rx: "1.833",
    width: "13.75",
    x: "27.75",
    y: "13.667"
  }), __jsx("rect", {
    height: "3.667",
    rx: "1.833",
    width: "13.75",
    x: "27.75",
    y: "19.778"
  }))), __jsx("g", {
    transform: "translate(35 .4)"
  }, __jsx("circle", {
    cx: "9.5",
    cy: "9.5",
    fill: "#4ca667",
    r: "9.5"
  }), __jsx("use", {
    fill: "#000",
    filter: "url(#b)",
    xlinkHref: "#a"
  }), __jsx("use", {
    fill: "#fff",
    xlinkHref: "#a"
  }))));
};
export default SvgIdSuccessIcon;